import { render, staticRenderFns } from "./NavigationMailbox.vue?vue&type=template&id=b5b17a20&scoped=true"
import script from "./NavigationMailbox.vue?vue&type=script&lang=js"
export * from "./NavigationMailbox.vue?vue&type=script&lang=js"
import style0 from "./NavigationMailbox.vue?vue&type=style&index=0&id=b5b17a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b17a20",
  null
  
)

export default component.exports